export default function Privacy() {
  return (
    <div className="section max-w-3xl">
      <h1 className="font-display text-3xl text-civitas-navy mb-2">Privacy Policy</h1>
      <p className="text-xs text-civitas-silver mb-8">Last updated: October 2026</p>

      <div className="card border-l-4 border-civitas-gold mb-8">
        <p className="text-civitas-navy font-medium">
          Match scores are calculated in your browser. Signed-in questionnaire answers and location preferences are also saved to your account.
        </p>
      </div>

      {[
        {
          title: '1. What Data We Collect',
          content: `We process account information when you sign in, questionnaire answers and location preferences when you save them, and addresses when you request a district lookup.`
        },
        {
          title: '2. How Questionnaire Data Is Stored',
          content: `Answers and district selections are saved in this browser. When signed in, your answers and location preferences are also saved to your account. Clearing browser storage does not delete account data.`
        },
        {
          title: '3. Matching and Location',
          content: `Matching calculations run in your browser. Address lookup sends the entered address for processing. The saved district selection does not include the street address. District lookup coverage can vary by location.`
        },
        {
          title: '4. External Links',
          content: `External lookup and evidence sites have their own privacy practices and may request information from you. The polling-place link does not include your entered address.`
        },
        {
          title: '5. Contact',
          content: `For privacy questions or account data requests, contact adam12beck@gmail.com or 2020consultingcontact@gmail.com.`
        },
      ].map(({ title, content }) => (
        <div key={title} className="mb-6">
          <h2 className="font-semibold text-civitas-navy mb-2">{title}</h2>
          <p className="text-sm text-civitas-silver leading-relaxed">{content}</p>
        </div>
      ))}
    </div>
  )
}
